export default __webpack_public_path__ + "static/media/DownloadIcon.e9dbb081.svg";